/// <reference path="./label.d.ts" />
import { GLabel, GLabelType, LabelData } from '../glabel';
import { PageGen, PdfUnit, PdfRect, PdfColor } from '../pdf';
import { PdfBrush, PdfFont, ETextAlign } from '../pdf';
import { GUtil } from '../gutil';

PageGen.prototype.drawLabel = function (label: GLabel, data: LabelData): void {
  const font = data.font ?? GUtil.baseFont;

  switch ((label as any).type as GLabelType) {
    case GLabelType.Text: {
      const text = (label as any).text as string;
      if (!text) break;
      const marginMm = data.rect.width > PdfUnit.FromMillimeters(30) ? 1 : 0.5;
      const innerRect = data.rect.deflate(PdfUnit.FromMillimeters(marginMm));
      if (data.singleLine) {
        const f = this.adjustFont(innerRect.width, [text], font);
        this.drawString(text, f, PdfBrush.Black, null, innerRect, ETextAlign.Center);
      } else {
        this.drawStringMulti(text, font, PdfBrush.Black, null, innerRect, ETextAlign.Center);
      }
      break;
    }
    case GLabelType.Image: {
      const {image} = (label as any);
      if (!image) break;
      this.drawImageFit(image, data.rect);
      break;
    }
    case GLabelType.ImageText: {
      const {image} = (label as any);
      const text = (label as any).text as string;
      if (image) {
        this.drawImageFit(image, data.rect);
      }
      if (text) {
        const textHeight = PdfUnit.FromMillimeters(12);
        const textRect = new PdfRect(
          data.rect.x,
          data.rect.y + data.rect.height - textHeight,
          data.rect.width,
          textHeight
        );
        this.drawRectangle(null, new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 1.0, 0.1)), textRect);
        const f = this.adjustFont(textRect.width, [text], font);
        this.drawString(text, f, PdfBrush.Black, null, textRect, ETextAlign.Center);
      }
      break;
    }
    case GLabelType.Generated: {
      const {callback} = (label as any);
      if (callback) {
        callback(label, { ...data, page: this });
      }
      break;
    }
  }
};
